import { CartDescriptionException, CartExceptionType } from '@cargos/sprintpay-models';

export const formTOUErrors = {
    termsOfUse: {
        code: 'required',
        message: CartDescriptionException[CartExceptionType.TERMS_OF_USE_INVALID],
    },
};
